import { SubjectActions } from '../../../../store'
import { connect } from 'react-redux'
import withAppShell from '../../../hoc/withAppShell/WithAppShell';
import React, { Component } from 'react';
import Subjects from './Subjects'
import lodashUtil from 'lodash';
import { SchoolInformationActions } from '../../../../store'
import { gradePickerUtil } from '../../gradePicker';
import { toast } from 'react-toastify';
import * as StringReplacer from '../../../../i18n/StringReplacer'
import { constructGradeLevelJSONToBeRenderedAllFalse } from '../../gradePicker/gradePickerUtil';
import { saveSchoolConcurrently } from '../../../../utils/ConcurrentSchoolSaveUtil';
class SubjectContainer extends Component {
  constructor(props) {
    super(props)
    this.state = {
      gradeLevelsToBeRendered: {},
      subjectList: [],
      electives: [],
      teachers: [],
      deletedSubjects: [],
      constraintsArray: [
        "numberOfTeachersAndTAsForSubjects",
        "fixedTeachersAndTAsForSubjects",
        "multiPeriods",
        "preferredPeriods",
        "sharedRoomsForSubjects",
        "totalPeriods",
        "jointClasses"
      ],
      confimationDialogSubjects: {
        isChanged: false
      },
      isSaved: false,
      deletedElectives: [],
      constraintsArrayForElective: [
        "numberOfTeachersAndTAsForElectives",
        "fixedTeachersAndTAsForElectives",
        "multiPeriods",
        "preferredPeriods",
        "sharedRoomsForElectives",
        "totalPeriods",
        "jointClasses"
      ]
    }
  }

  // if subjects are deleted then the electives list has to be updated remove the particular subject and 
  // if the length of the elective is lesser than 2 then delete the entire row.
  updatingElectivesList = (subject) => {
    let electviesList = JSON.parse(JSON.stringify(this.props.activeSchool.school_master.electives));
    let deletedElectivesList = []
    for (let i = 0; i < electviesList.length; i++) {
      lodashUtil.remove(electviesList[i].subjects, function (subjectArray) {
        if (subjectArray.subjectId === subject._id) {
          deletedElectivesList.push(electviesList[i])
        }
        return subjectArray.subjectId === subject._id
      })
    }
    for (let j = 0; j < electviesList.length; j++) {
      if (electviesList[j].subjects.length < 2) {
        deletedElectivesList.push(electviesList[j])
        electviesList.splice(j, 1);
        j -= 1;
      }
    }
    this.setState({ electives: electviesList, deletedElectives: deletedElectivesList });
  }

  //if any subejct is deleted and if that subject is assigned to a teacher it needs to be updated in the teachers also.
  updatingTeacherAssignedSub = (subject) => {
    // giving props.activeSchool as "REFERENCE" so we dont need to do any set state or assign it to the teachers inside activeSchool
    let teachers
    if (this.state.teachers.length !== 0) {
      teachers = this.state.teachers
    } else {
      teachers = JSON.parse(JSON.stringify(this.props.activeSchool.school_master.teachers));
    }
    for (let i = 0; i < teachers.length; i++) {
      let assignedSubjects = teachers[i].assignedSubjects;
      let findingSub = lodashUtil.findIndex(assignedSubjects, ["subjectId", subject._id]);
      if (findingSub !== -1) {
        assignedSubjects.splice(findingSub, 1);
      }
    }
    this.setState({
      teachers: teachers
    })

  }

  // deleting the row.
  removeSubjectFromSubjectList = (key) => {
    let subjectList = this.state.subjectList
    let subjectName = subjectList[key].name;
    this.state.deletedSubjects.push({ subjectName: subjectName })
    this.updatingElectivesList(subjectList[key]);
    this.updatingTeacherAssignedSub(subjectList[key]);
    subjectList.splice(key, 1)
    this.setState({
      subjectList: subjectList,
    })
  }


  componentWillMount = async () => {
    const i18n = this.props.i18n
    if (this.props.activeSchool.school_master === undefined) {
      toast(i18n.toastMsgs.noDataInSchoolIndormationMsg)
      this.props.previousStep()
    }
    else if (this.props.activeSchool.school_master.gradeLevels.length === 0) {
      toast(i18n.toastMsgs.noDataInGradeMsg)
      this.props.previousStep(false)
    }
    else {
      let gradeLevelsToBeRendered = { gradeLevels: [...this.props.activeSchool.school_master.gradeLevels] }
      gradeLevelsToBeRendered = gradePickerUtil.constructGradeLevelJSONToBeRendered(gradeLevelsToBeRendered)
      let electives = this.props.activeSchool.school_master.electives
      let teachers = this.props.activeSchool.school_master.teachers
      let subjectList
      if (!lodashUtil.isEmpty(this.props.activeSchool.school_master.subjects)) {
        if (this.props.activeSchool.school_master.subjects.length > 0) {
          subjectList = JSON.parse(JSON.stringify(this.props.activeSchool.school_master.subjects))
          subjectList = lodashUtil.orderBy(subjectList, ['name'], ['asc'])
          this.setState({
            subjectList: subjectList,
          })
        }
      }
      await this.props.getSubjectMasterData();
      this.setState({
        gradeLevelsToBeRendered: gradeLevelsToBeRendered,
        electives: electives,
        teachers: teachers
      })
    }
  }

  updatingAssignedSubjects = (subjectsWithIds) => {
    let teachers
    let electviesList
    if (this.state.teachers.length !== 0) {
      teachers = this.state.teachers
    } else {
      teachers = JSON.parse(JSON.stringify(this.props.activeSchool.school_master.teachers));
    }
    electviesList = this.state.electives
    let subjectArray = this.props.activeSchool.school_master.subjects;
    for (let j = 0; j < subjectArray.length; j++) {
      subjectsWithIds.map((subjectObj) => {
        if (subjectArray[j]._id == subjectObj._id && subjectArray[j].name !== subjectObj.name
          || subjectArray[j]._id == subjectObj._id && subjectArray[j].code !== subjectObj.code) {
          for (let i = 0; i < teachers.length; i++) {
            let assignedSubjects = teachers[i].assignedSubjects;
            assignedSubjects.map((assignedSubjectObj) => {
              if (assignedSubjectObj.subjectId === subjectObj._id) {
                assignedSubjectObj.subjectName = subjectObj.name
                assignedSubjectObj.subjectCode = subjectObj.code
              }
            })
          }
          for (let i = 0; i < electviesList.length; i++) {
            let selectedSubjects = electviesList[i].subjects;
            selectedSubjects.map((electiveObj) => {
              if (electiveObj.subjectId == subjectObj._id) {
                electiveObj.name = subjectObj.name
                electiveObj.subjectCode = subjectObj.code
              }
            })
          }
        }
      })
    }
    return {
      teachers,
      electviesList
    }
  }

  updateSubjectInRules = (subjectsWithIds, updateSubject, subjectArray, scheduleObj) => {
    if (updateSubject.length !== 0) {
      let isSCheduleUpdated = false
      for (let a = 0; a < subjectArray.length; a++) {
        subjectsWithIds.map((subjectObj) => {
          if ((subjectArray[a]._id == subjectObj._id && subjectArray[a].name !== subjectObj.name)
            || (subjectArray[a]._id == subjectObj._id && subjectArray[a].code !== subjectObj.code)) {
            updateSubject.map((updateSubjectObj) => {
              if (updateSubjectObj.subjectId !== undefined) {
                if (updateSubjectObj.subjectId === subjectObj._id) {
                  updateSubjectObj.subjectName = subjectObj.name
                  updateSubjectObj.subjectCode = subjectObj.code
                  if (scheduleObj.status === 'Completed') {
                    updateSubjectObj.isDirty = true;
                  }
                  scheduleObj.isSCheduleUpdated = true
                }
              }
            })
          }
        })
      }
      return updateSubject
    }
  }

  updateSubjectInRulesElectives = (electivesArray, updateElective, scheduleObj) => {
    for (let i = 0; i < electivesArray.length; i++) {
      if (electivesArray.length !== 0) {
        let subjectObj = electivesArray[i]
        updateElective.map((updateElectiveObj) => {
          if (subjectObj._id == updateElectiveObj.subjectId && subjectObj.name !== updateElectiveObj.subjectName
            || subjectObj._id == updateElectiveObj.subjectId && subjectObj.code !== updateElectiveObj.subjectCode) {
            updateElectiveObj.subjectName = subjectObj.name
            updateElectiveObj.subjectCode = subjectObj.subjectCode
            if (scheduleObj.status === 'Completed') {
              updateElectiveObj.isDirty = true;
            }
            scheduleObj.isSCheduleUpdated = true;
          }
        })
      }
    }
  }

  updateRules = async (newSubjectArray, updatedListOfSubjects) => {
    let schedule_constraints = this.props.activeSchool.schedule_constraints
    let subjectArray = JSON.parse(JSON.stringify(this.props.activeSchool.school_master.subjects));
    await this.deletingSubjectObjInRules(schedule_constraints)
    this.deletingElectiveObjInRules(schedule_constraints)
    if (schedule_constraints !== undefined && schedule_constraints.length !== 0) {
      for (let i = 0; i < schedule_constraints.length; i++) {
        let numberOfTeacherAndTAs = schedule_constraints[i].numberOfTeachersAndTAsForSubjects
        await this.updateSubjectInRules(newSubjectArray, numberOfTeacherAndTAs, subjectArray, schedule_constraints[i])

        let fixedTeachersAndTAsForSubjects = schedule_constraints[i].fixedTeachersAndTAsForSubjects
        await this.updateSubjectInRules(newSubjectArray, fixedTeachersAndTAsForSubjects, subjectArray, schedule_constraints[i])

        let sharedRoomsForSubjects = schedule_constraints[i].sharedRoomsForSubjects
        await this.updateSubjectInRules(newSubjectArray, sharedRoomsForSubjects, subjectArray, schedule_constraints[i])

        let multiPeriods = schedule_constraints[i].multiPeriods
        await this.updateSubjectInRules(newSubjectArray, multiPeriods, subjectArray, schedule_constraints[i])

        let preferredPeriods = schedule_constraints[i].preferredPeriods
        await this.updateSubjectInRules(newSubjectArray, preferredPeriods, subjectArray, schedule_constraints[i])

        let totalPeriods = schedule_constraints[i].totalPeriods
        await this.updateSubjectInRules(newSubjectArray, totalPeriods, subjectArray, schedule_constraints[i])

        let jointClasses = schedule_constraints[i].jointClasses
        await this.updateSubjectInRules(newSubjectArray, jointClasses, subjectArray, schedule_constraints[i])

        let electives = updatedListOfSubjects.electviesList
        let electivesArray = []
        for (let n = 0; n < electives.length; n++) {
          let subjects = electives[n].subjects
          for (let b = 0; b < subjects.length; b++) {
            let subject = subjects[b]
            if (subject._id !== undefined) {
              electivesArray.push(subject)
            }
          }
        }
        let numberOfTeachersAndTAsForElectives = schedule_constraints[i].numberOfTeachersAndTAsForElectives
        let fixedTeachersAndTAsForElectives = schedule_constraints[i].fixedTeachersAndTAsForElectives
        let sharedRoomsForElectives = schedule_constraints[i].sharedRoomsForElectives

        if (numberOfTeachersAndTAsForElectives.length !== 0) {
          for (let k = 0; k < numberOfTeachersAndTAsForElectives.length; k++) {
            let teacherAndTAs = numberOfTeachersAndTAsForElectives[k].teachersAndTAs
            this.updateSubjectInRulesElectives(electivesArray, teacherAndTAs, schedule_constraints[i])
            let ruleArray = await this.deletingSubjectObjectInRulesForElectives(teacherAndTAs, schedule_constraints[i])
            if (ruleArray !== undefined && ruleArray.length === 0) {
              if (schedule_constraints[i].status !== 'Completed') {
                numberOfTeachersAndTAsForElectives.splice(k, 1)
                k -= 1;
              } else {
                numberOfTeachersAndTAsForElectives[k].isDirty = true;
                schedule_constraints[i].isSCheduleUpdated = true;
              }
            }
          }
        }
        if (fixedTeachersAndTAsForElectives.length !== 0) {
          for (let k = 0; k < fixedTeachersAndTAsForElectives.length; k++) {
            let fixedTeacherAndTAs = fixedTeachersAndTAsForElectives[k].teachersAndTAs
            this.updateSubjectInRulesElectives(electivesArray, fixedTeacherAndTAs, schedule_constraints[i])
            let ruleArray = await this.deletingSubjectObjectInRulesForElectives(fixedTeacherAndTAs, schedule_constraints[i])
            if (ruleArray !== undefined && ruleArray.length === 0) {
              if (schedule_constraints[i].status !== 'Completed') {
                fixedTeachersAndTAsForElectives.splice(k, 1)
                k -= 1;
              } else {
                fixedTeachersAndTAsForElectives[k].isDirty = true;
                schedule_constraints[i].isSCheduleUpdated = true;
              }
            }
          }
        }
        if (sharedRoomsForElectives.length !== 0) {
          
          for (let k = 0; k < sharedRoomsForElectives.length; k++) {
            let subjects = sharedRoomsForElectives[k].subjects
            this.updateSubjectInRulesElectives(electivesArray, subjects, schedule_constraints[i])
            let ruleArray = await this.deletingSubjectObjectInRulesForElectives(subjects, schedule_constraints[i])
            console.log(308,ruleArray)
            if (ruleArray !== undefined && ruleArray.length === 0) {
              if (schedule_constraints[i].status !== 'Completed') {
                
                sharedRoomsForElectives.splice(k, 1)
                k -= 1;
              } else {
                sharedRoomsForElectives[k].isDirty = true;
                schedule_constraints[i].isSCheduleUpdated = true;
              }
            }

          }
        }
        if (schedule_constraints[i].isSCheduleUpdated !== undefined && schedule_constraints[i].isSCheduleUpdated === true) {
          schedule_constraints[i].version = schedule_constraints[i].version + 1
        }
      }
    }
    return schedule_constraints
  }



  deletingSubjectObjInRules = (scheduleConstraints) => {
    if (scheduleConstraints !== undefined && scheduleConstraints.length != 0) {
      let constraintsArray = this.state.constraintsArray
      let deletedSubjects = this.state.deletedSubjects
      if (deletedSubjects.length !== 0) {
        for (let i = 0; i < scheduleConstraints.length; i++) {
          let scheduleObj = scheduleConstraints[i]
          let isSCheduleUpdated = false;
          for (let j = 0; j < constraintsArray.length; j++) {
            let ruleName = constraintsArray[j]
            let ruleArray = scheduleObj[ruleName]
            if (ruleArray.length > 0) {

              for (let k = 0; k < ruleArray.length; k++) {
                let subject = ruleArray[k]
                if (subject.subjectId !== undefined) {
                  let subjectPresent = lodashUtil.find(deletedSubjects, ["subjectName", subject.subjectName])
                  if (subjectPresent !== undefined) {
                    if (scheduleObj.status !== 'Completed') {
                      ruleArray.splice(k, 1)
                      k -= 1;
                      scheduleObj.isSCheduleUpdated = true;
                    } else {
                      ruleArray[k].isDirty = true;
                      scheduleObj.isSCheduleUpdated = true;
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    return scheduleConstraints;
  }
  deletingElectiveObjInRules = (scheduleConstraints) => {
    if (scheduleConstraints !== undefined && scheduleConstraints.length > 0) {
      let constraintsArray = this.state.constraintsArrayForElective
      let deletedElectives = this.state.deletedElectives
      if (deletedElectives.length > 0) {
        for (let i = 0; i < scheduleConstraints.length; i++) {
          let scheduleObj = scheduleConstraints[i]
          let isSCheduleUpdated = false;
          for (let j = 0; j < constraintsArray.length; j++) {
            let ruleName = constraintsArray[j]
            let ruleArray = scheduleObj[ruleName]
            if (ruleArray.length > 0) {

              for (let k = 0; k < ruleArray.length; k++) {
                let elective = ruleArray[k]
                if (elective.electiveId !== undefined) {
                  let electivePresent = lodashUtil.find(deletedElectives, ["name", elective.electiveName])
                  if (electivePresent !== undefined) {
                    if (scheduleObj.status !== 'Completed') {
                      ruleArray.splice(k, 1)
                      k -= 1;
                      scheduleObj.isSCheduleUpdated = true;
                    } else {
                      ruleArray[k].isDirty = true;
                      scheduleObj.isSCheduleUpdated = true;
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  deletingSubjectObjectInRulesForElectives = (ruleArray, scheduleObj) => {
    
    let deletedSubjects = this.state.deletedSubjects
    if (deletedSubjects.length !== 0) {
      for (let k = 0; k < ruleArray.length; k++) {
        let subject = ruleArray[k]
        if (subject.subjectId !== undefined) {
          let subjectPresent = lodashUtil.find(deletedSubjects, ["subjectName", subject.subjectName])
          if (subjectPresent !== undefined) {
            if (ruleArray.length === 2) {
              if (scheduleObj.status !== 'Completed') {
                ruleArray = []
                scheduleObj.isSCheduleUpdated = true;
              } else {
                ruleArray[0].isDirty = true;
                ruleArray[1].isDirty = true;
                scheduleObj.isSCheduleUpdated = true;
              }
            } else {
              if (scheduleObj.status !== 'Completed') {
                ruleArray.splice(k, 1)
                k -= 1;
                scheduleObj.isSCheduleUpdated = true;
              } else {
                ruleArray[k].isDirty = true;
                scheduleObj.isSCheduleUpdated = true;
              }
            }
          }
        }
      }
      
      console.log(434,ruleArray)
      return ruleArray
    }
  }
  onClickOfSave = async () => {
    const i18n = this.props.i18n
    let subjects = this.state.subjectList;
    let repeactSubjectName = false;
    let isSubjectNameEmpty = lodashUtil.find(subjects, { "name": "" });
    if (isSubjectNameEmpty != undefined) {
      toast(i18n.subjects.subjectNameIsEmpty);
    } else {
      for (let i = 0; i < subjects.length - 1; i++) {
        for (let j = i + 1; j < subjects.length; j++) {
          if (subjects[i].name.toLowerCase() === subjects[j].name.toLowerCase()) {
            repeactSubjectName = true;
            let errorMessage_repeatingSubjectName = StringReplacer.getFormatedMessage(i18n.subjects.repeatingSubjectName,
              {
                Subject: subjects[j].name,
              })
            toast(errorMessage_repeatingSubjectName)
            break;
          }
        }

      }
      if (repeactSubjectName === false) {
        if (!this.validationForSubjectCode()) {
          let newSubjectArray = []
          for (let i = 0; i < subjects.length; i++) {
            let subject = subjects[i]
            if (subject._id !== undefined) {
              newSubjectArray.push(subject)
            }
          }

          let updatedListOfSubjects = this.updatingAssignedSubjects(newSubjectArray)

          let schedule_constraints = await this.updateRules(newSubjectArray, updatedListOfSubjects)

          let tempActiveSchool = this.props.activeSchool
          tempActiveSchool.school_master.subjects = this.state.subjectList
          tempActiveSchool.schedule_constraints = schedule_constraints
          tempActiveSchool.school_master.electives = updatedListOfSubjects.electviesList
          tempActiveSchool.school_master.teachers = updatedListOfSubjects.teachers
          tempActiveSchool.school_master.modifiedDate = new Date()
          //await this.props.editSchoolInformation(this.props.userInformation._id, this.props.activeSchool._id, tempActiveSchool)
          //toast(i18n.toastMsgs.subjectsSavedSuccessfully);

          // let result = await saveSchoolConcurrently(this.props.editSchoolInformation,
          //   this.props.userInformation._id,
          //   this.props.activeSchool._id, 
          //   tempActiveSchool,
          //   i18n.toastMsgs.subjectsSavedSuccessfully);
          let result = await saveSchoolConcurrently(this.props.editSchoolInformation,
            this.props.userInformation._id,
            this.props.activeSchool._id,
            tempActiveSchool,
            i18n.toastMsgs.subjectsSavedSuccessfully);
          this.setState({
            confimationDialogSubjects: {
              isChanged: false
            }
          })
        }
      }
    }
  }

  validationForSubjectCode = () => {
    const i18n = this.props.i18n
    let subjectMasterData = this.props.subjectMasterData.subjects
    let subjectList = this.state.subjectList
    for (let i = 0; i < subjectList.length; i++) {
      subjectList[i].code = subjectList[i].code.trim()
      let subjectCode = subjectList[i].code
      let subjectName = subjectList[i].name
      let repeatingCode = lodashUtil.filter(subjectList, ['code', subjectCode.trim()])
      if (repeatingCode.length > 1) {
        let errorMessage_uniqueSubjectCode = StringReplacer.getFormatedMessage(i18n.subjects.uniqueSubjectCode,
          {
            subjectCode: subjectCode,
            subjectName: subjectName
          })
        toast(errorMessage_uniqueSubjectCode);
        return true
      } else {
        let subjectName = subjectList[i].name
        let subjectObj = lodashUtil.find(subjectMasterData, ['subjectName', subjectName])
        if (subjectObj === undefined) {
          if (subjectCode !== "") {
            let codeInMasterData = lodashUtil.find(subjectMasterData, ['subjectId', subjectCode])
            if (codeInMasterData !== undefined) {
              let errorMessage_subjectCodeAlreadyAssigned = StringReplacer.getFormatedMessage(i18n.subjects.subjectCodeAlreadyAssigned,
                {
                  subjectCode: subjectCode,
                  subjectName: codeInMasterData.subjectName
                })
              toast(errorMessage_subjectCodeAlreadyAssigned);
              return true
            }
          } else {
            toast(i18n.subjects.emptySubjectCode);
            return true
          }
        }
      }
    }
    return false
  }

  showContextualHelp = (props, event) => {
    let content = props.contextualHelp["subjects"];
    if (content !== undefined) {
      props.toggleDrawer("right", true, content)(event)
    }
  }

  componentWillUnmount = async () => {
    if (this.state.confimationDialogSubjects.isChanged) {
      await this.beforeUnload()
    }
  }

  undoChanges = () => {
    let confimationDialogSubjects = this.state.confimationDialogSubjects
    confimationDialogSubjects.isChanged = false
    this.setState({
      confimationDialogSubjects: confimationDialogSubjects
    })
  }
  beforeUnload = async () => {
    const i18n = this.props.i18n
    var flag = window.confirm(i18n.subjects.msgForUnsavedChangesInTab);
    if (flag) {
      if (!this.state.isSaved) {
        await this.onClickOfSave()
      }
    }
    else {
      this.undoChanges()
    }
  }
  render() {

    return <Subjects
      {...this.state}
      {...this.props}
      onClickOfSave={this.onClickOfSave}
      removeSubjectFromSubjectList={this.removeSubjectFromSubjectList}
      showContextualHelp={this.showContextualHelp}
      beforeUnload={this.beforeUnload}
    />
  }
}

const mapDispatchToProps = (dispatch) => ({
  getSubjectMasterData: () => dispatch(SubjectActions.getSubjectMasterData()),
  editSchoolInformation: (ownerId, schoolId, data) => dispatch(SchoolInformationActions.editSchoolInformation(ownerId, schoolId, data)),
  updatedSchoolMaster: (ownerId, schoolId, data) => dispatch(SchoolInformationActions.updatedSchoolMaster(ownerId, schoolId, data))
})

const mapStateToProps = (state, ownprops) => {
  return {
    subjectMasterData: state.subjectInformation.subjectMasterDataList,
    activeSchool: state.schoolInformation.activeSchool,
    getSubjectsInProgress: state.subjectInformation.getSubjectsInProgress,
    getSubjectMasterDataInProgress: state.subjectInformation.getSubjectMasterDataInProgress,
    updateSchoolinformationInProgress: state.schoolInformation.updateSchoolinformationInProgress

  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withAppShell(SubjectContainer))
